import React from "react";
import Ajax, { domain } from "../../ajax/Ajax";
import { Loading } from "../../App";
import queryString from "query-string";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet/es/Helmet";
import logo from "../../images/logo.png";
import defaultuser from "../../images/defaultuser.png";
import ReactStars from "react-rating-stars-component";
import Signup from "../account/Signup";
import Login from "../account/Login";
import OwlCarousel from "react-owl-carousel";

class ProductDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: JSON.parse(localStorage.getItem("user")),
      product: null,
      pid: null,
      stockId: null,
      comments: [],
      nextComments: null,
      prevComments: null,
      showSignupForm: false,
      showLoginForm: false,
      comment: "",
      posting: false,
      postingCommentError: false,
      postingCommentSuccessful: false,
      hasRatedProduct: false,
      checkingProductRating: false,
      rating: null,
    };

    this.fetchProductDetails = this.fetchProductDetails.bind(this);
    this.getProductComments = this.getProductComments.bind(this);
    this.postComment = this.postComment.bind(this);
    this.toggleSignupLogin = this.toggleSignupLogin.bind(this);
    this.submitProductRating = this.submitProductRating.bind(this);
    this.getProductRating = this.getProductRating.bind(this);
    this.setUser = this.setUser.bind(this);

    this.productDetailsModal = React.createRef();
    this.owlcarousel = React.createRef();
  }

  async fetchProductDetails(pid) {
    console.log("fetching product details");
    let response = await Ajax.fetchData(
      domain + "/en/api/market/v1/product/details/?pid=" + pid
    );
    console.log(response, "response from server");
    if (response) {
      console.log(response, "product details");
      if (response.status === 200) {
        this.setState({
          product: response.product,
        });
      }
    }
  }

  setUser(user) {
    this.setState({
      user: user,
      showSignupForm: false,
    });
  }

  toggleSignupLogin(status) {
    this.setState({
      showLoginForm: status,
    });
  }

  async getProductComments() {
    if (this.state.pid) {
      let params = "?pid=" + this.state.pid;

      let response = await Ajax.fetchData(
        domain + "/en/api/market/v1/product/comments/" + params
      );
      if (response) {
        console.log(response);
        this.setState({
          comments: response.results,
          nextComments: response.next,
          prevComments: response.prev,
        });
      }
    }
  }

  async getProductRating() {
    if (localStorage.getItem("token")) {
      if (this.state.pid && localStorage.getItem("token")) {
        this.setState({
          checkingProductRating: true,
        });
        let response = await Ajax.fetchData(
          domain + "/en/api/market/v1/product/ratings/?pid=" + this.state.pid,
          true
        );
        if (response) {
          if (response.rating) {
            this.setState({
              hasRatedProduct: true,
              rating: response.rating,
              checkingProductRating: false,
            });
          } else {
            this.setState({
              checkingProductRating: false,
            });
          }
        } else {
          this.setState({
            checkingProductRating: false,
          });
        }
      }
    }
  }

  async submitProductRating(rating) {
    if (localStorage.getItem("token")) {
      if (this.state.pid) {
        let data = {
          rating: rating,
          pid: this.state.pid,
        };

        let response = await Ajax.postData(
          domain + "/en/api/market/v1/product/ratings/",
          data
        );
        if (response) {
          if (response.status === 200) {
            this.setState({
              hasRatedProduct: true,
              rating: rating,
            });
          }
        }
      }
    } else {
      console.log("no user");
      this.setState({
        showSignupForm: true,
      });
    }
  }

  async postComment(event) {
    event.preventDefault();

    if (this.state.user) {
      console.log(this.state.user);
      let data = {
        comment: this.state.comment,
        pid: this.state.pid,
      };

      this.setState({
        posting: true,
        postingCommentError: false,
        postingCommentSuccessful: false,
      });
      let response = await Ajax.postData(
        domain + "/en/api/market/v1/product/comments/",
        data
      );
      if (response) {
        if (response.status === 200) {
          let comments = this.state.comments;
          comments.unshift(response.comment);
          this.setState({
            posting: false,
            comments: comments,
            comment: "",
            postingCommentSuccessful: true,
          });
        }
      } else {
        this.setState({
          posting: false,
          postingCommentError: true,
        });
      }
    } else {
      console.log("no user");
      this.setState({
        showSignupForm: true,
      });
    }
  }

  async componentDidMount() {
    let urlParams = queryString.parse(this.props.location.search);
    console.log("at product details", urlParams);

    let urlState = this.props.location.state;
    if (urlState) {
      await this.setState({
        pid: urlState.product.item.pid,
        product: urlState.product,
      });
    } else {
      //fetch from server using urlParams
      console.log(urlParams);
      this.fetchProductDetails(urlParams.pid);
    }

    this.getProductComments();
    this.getProductRating();
  }

  render() {
    let product = this.state.product;
    let posting = "";
    if (this.state.posting) {
      posting = "is-loading";
    }
    return (
      <div className="m-1">
        {this.state.product ? (
          <Helmet>
            <link rel="icon" href={logo} />
            <title>{product.item.name}</title>
          </Helmet>
        ) : (
          <div></div>
        )}

        <div
          id="product-details-modal"
          ref={this.productDetailsModal}
          className="modal is-active animated zoomIn"
        >
          <div className="modal-background"></div>
          <div className="modal-card">
            <header className="modal-card-head">
              {product ? (
                <p className="modal-card-title">{product.item.name}</p>
              ) : (
                <p className="modal-card-title">Product Details</p>
              )}

              <div className="mr-2">
                <Link
                  to={
                    this.props.shop
                      ? `/shop-at/${this.props.shop.name.replace(
                          /\s+/g,
                          "-"
                        )}/${this.props.shop.id}/`
                      : "/market/"
                  }
                >
                  <button className="delete" aria-label="close"></button>
                </Link>
              </div>
            </header>
            <section className="modal-card-body has-background-light">
              {this.state.product ? (
                <div className="card is-shadowless has-background-light">
                  <div
                    title="Select to learn more"
                    className="card-image static-link product-image"
                  >
                    <div className="columns">
                      <div className="column is-11">
                        {product.item.gallery ? (
                          <OwlCarousel
                            ref={this.owlcarousel}
                            className="owl-theme"
                            loop
                            items={1}
                            margin={10}
                          >
                            {product.item.gallery.map((image) => (
                              <div key={image.id + "-product-image"}>
                                <figure
                                  title={product.item.name}
                                  className="image"
                                >
                                  <img src={domain + image.url} alt="" />
                                </figure>
                              </div>
                            ))}
                          </OwlCarousel>
                        ) : (
                          <div></div>
                        )}
                      </div>
                      {product.item.gallery.length > 1 ? (
                        <div className="column is-1 d-flex align-items-center justify-content-center">
                          <button
                            type="button"
                            title="Forward"
                            onClick={() => {
                              this.owlcarousel.current.next();
                            }}
                            className="button is-white is-round"
                          >
                            <span className="fas fa-angle-right"></span>
                          </button>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                  <div className="m-2">
                    <p className="has-text-left product-name">
                      <strong>{product.item.name}</strong>
                    </p>
                    <div className="has-text-left description">
                      {product.item.description}
                    </div>
                    <div className="d-flex justify-content-between price-and-stock-field">
                      <span className="has-text-info">
                        <span>{product.shop.currency}</span>{" "}
                        {product.item.price.toLocaleString()}
                      </span>
                      <span className="has-text-info">
                        {product.item.stock > 10 ? (
                          <strong>
                            <small className="has-text-success">
                              Available
                            </small>
                          </strong>
                        ) : (
                          <strong>
                            <small className="has-text-danger">Limited</small>
                          </strong>
                        )}
                      </span>
                    </div>

                    <div className="shop has-text-left">
                      <p>{product.shop.name}</p>
                      <p className="shop-address">
                        {product.shop.address}
                        <span>({product.shop.phone})</span>
                      </p>
                      <p className="m-1">
                        <strong>
                          {product.shop.distance ? (
                            <span>
                              ~{Number(product.shop.distance).toLocaleString()}m
                              from you{" "}
                            </span>
                          ) : (
                            <span>Unknown distance from you</span>
                          )}
                        </strong>
                      </p>
                    </div>

                    <div>
                      <hr />

                      {!this.state.showSignupForm ? (
                        <div>
                          {!this.state.hasRatedProduct &&
                          !this.state.checkingProductRating ? (
                            <div>
                              <div>
                                <strong>
                                  <i>Rate this Product</i>
                                </strong>
                              </div>
                              <ReactStars
                                count={5}
                                onChange={this.submitProductRating}
                                size={25}
                                color2={"#ffd700"}
                              />
                            </div>
                          ) : (
                            <div className="has-text-success has-text-centered">
                              {this.state.rating ? (
                                <b>
                                  <span>
                                    You rated this product with{" "}
                                    {this.state.rating}/5
                                  </span>
                                </b>
                              ) : (
                                <span></span>
                              )}
                            </div>
                          )}

                          <form
                            action="#"
                            onSubmit={this.postComment}
                            className="mt-2"
                          >
                            {this.state.postingCommentError ? (
                              <div className="message is-danger">
                                <div className="message-body">
                                  Something went wrong. Try again
                                </div>
                              </div>
                            ) : (
                              <div></div>
                            )}

                            {this.state.postingCommentSuccessful ? (
                              <div className="message is-success">
                                <div className="message-body">
                                  Comment has been submitted
                                </div>
                              </div>
                            ) : (
                              <div></div>
                            )}
                            <div className="field">
                              <textarea
                                value={this.state.comment}
                                onChange={(event) =>
                                  this.setState({
                                    comment: event.target.value,
                                  })
                                }
                                required
                                placeholder="comment on this product"
                                name="comment"
                                className="textarea"
                                rows="3"
                              />
                            </div>
                            <div className="field has-text-left">
                              <button className={"button " + posting}>
                                Post
                              </button>
                            </div>
                          </form>
                        </div>
                      ) : (
                        <div className="card is-shadowless bordered-card">
                          <div className="card-content">
                            {!this.state.showLoginForm ? (
                              <Signup
                                toggleSigupLogin={this.toggleSignupLogin}
                                setUser={this.setUser}
                              />
                            ) : (
                              <Login
                                toggleSigupLogin={this.toggleSignupLogin}
                                setUser={this.setUser}
                              />
                            )}
                          </div>
                        </div>
                      )}

                      <hr />
                      <div>
                        <strong>
                          {" "}
                          What people are saying about this product
                        </strong>
                      </div>
                      <div>
                        {this.state.comments.length > 0 ? (
                          <div>
                            {this.state.comments.map((comment) => (
                              <div
                                className="card is-shadowless bordered-card mt-4"
                                key={comment.id + "-comment"}
                              >
                                <div className="card-content">
                                  <div className="">
                                    <div className="d-flex align-items-center">
                                      <figure className="image is-48x48">
                                        <img
                                          className="is-rounded"
                                          src={defaultuser}
                                          alt=""
                                        />
                                      </figure>
                                      <div className="ml-2">
                                        <p>
                                          <strong>{comment.user}</strong>
                                        </p>
                                        <p className="has-text-info">
                                          <i>
                                            <small>
                                              {new Date(
                                                comment.date
                                              ).toDateString()}{" "}
                                              {new Date(
                                                comment.date
                                              ).toLocaleTimeString()}
                                            </small>
                                          </i>
                                        </p>
                                      </div>
                                    </div>

                                    <p className="ml-2 mt-2">
                                      {comment.comment}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="has-text-centered mt-4">
                            <i>Be the first to comment on this product</i>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  <Loading />
                </div>
              )}
            </section>
            {product ? (
              <footer className="modal-card-foot d-flex justify-content-between">
                <Link
                  to={
                    this.props.shop
                      ? {
                          pathname:
                            "/shop-at/" +
                            product.shop.name.replace(/\s+/g, "-") +
                            "/" +
                            product.shop.id +
                            "/cart/add/?pid=" +
                            product.item.id,
                          state: {
                            product: product,
                          },
                        }
                      : {
                          pathname: "/market/cart/add/?pid=" + product.item.id,
                          state: {
                            product: product,
                          },
                        }
                  }
                >
                  <button
                    title="Add to Cart"
                    className="button is-outlined is-info"
                  >
                    <span className="zmdi zmdi-shopping-cart-add mr-1"></span>
                    Add to Cart
                  </button>
                </Link>

                <Link
                  to={
                    this.props.shop
                      ? {
                          pathname:
                            "/shop-at/" +
                            product.shop.name.replace(/\s+/g, "-") +
                            "/" +
                            product.shop.id +
                            "/order/?pid=" +
                            product.item.id,
                          state: {
                            product: product,
                          },
                        }
                      : {
                          pathname: "/market/order/?pid=" + product.item.id,
                          state: {
                            product: product,
                          },
                        }
                  }
                >
                  <button
                    title="Place Order to Shop"
                    className="button is-outlined is-primary"
                  >
                    <span className="zmdi zmdi-money mr-1"></span>
                    Order
                  </button>
                </Link>
              </footer>
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default ProductDetails;
